module.exports = __webpack_public_path__ + "media/flags/si-4fa73a7e.svg";